export default {
  title: 'Detalii livrare',
  buttons: {
    save: 'Salvați',
  },
};
